import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRubyonrailsComponent } from './simple-icons-rubyonrails.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRubyonrailsComponent ],
    exports:      [ SimpleIconsRubyonrailsComponent ],
    bootstrap:    []
})
export class SimpleIconsRubyonrailsModule {}
